import { ProjectTabDto } from '../api_client/parameter_api';

export const getUpdatedTabs = (tabs: Array<ProjectTabDto>, isHidden: boolean) =>
  tabs.map(tab => ({ ...tab, hidden: isHidden }));
